import React from 'react';
import Reflux from 'reflux';
import history from '../history';
import AppStore from '../AppStore';
import AppActions from '../AppActions';
import {Redirect} from 'react-router-dom';
import {Button} from 'react-materialize';
import TopBox from '../components/topic/TopBox';
import ErrorSign from './ErrorSign';
import RcIf from 'rc-if';

class NewTopic extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            title: '',
            topicCreated: false,
            options: [{position: 1}, {position: 2}, {position: 3}, {position: 4}, {position: 5}],
            errors: [],
            step: 0,
            warning: false
        };
        this.store = AppStore;
        this.handleChangeTitle = this.handleChangeTitle.bind(this);
        this.handleChangeOption = this.handleChangeOption.bind(this);
        this.handleNewTopic = this.handleNewTopic.bind(this);
        this.validateTopic = this.validateTopic.bind(this);
        this.goMakeTop = this.goMakeTop.bind(this);
    }
    componentDidMount () {
        AppActions.newTopicStart();
        AppActions.cleanOptions();
    }
    handleChangeTitle (event) {
        let expr1 = 'TOP5';
        let expr2 = 'TOP 5';
        this.setState({title: event.target.value});
        if (event.target.value && event.target.value.length > 0) {
            if ((event.target.value.toUpperCase().indexOf(expr1) >= 0 || event.target.value.toUpperCase().indexOf(expr2) >= 0) && !this.state.warning) {
                this.setState({ warning: true });
            }
            if ((event.target.value.toUpperCase().indexOf(expr1) === -1 && event.target.value.toUpperCase().indexOf(expr2) === -1) && this.state.warning) {
                this.setState({ warning: false });
            }
        }
    }
    handleChangeOption (event) {
        let target = event.target;
        let position = target.name;

        if (position < 1 || position > 5) {
            console.error('The position should be between 1 and 5');
            return;
        }
        let options = this.state.options;
        options[position - 1].sentence = target.value;
        this.setState({options: options});
    }
    createTopic = () => {
        if (this.validateTopic() && !this.state.uploadingTopic) {
            let options = this.state.options.filter((option) => {
                if (option.sentence) {
                    return option;
                }
            });
            let topic = {
                options,
                title: this.state.title
            };
            AppActions.createTopic(topic);
        }
    }
    validateTopic () {
        let valid = true;
        let errors = [];
        if (!this.state.title) {
            errors.push('El titulo es un campo requerido.');
            valid = false;
        }
        let options = this.state.options.filter((option) => {
            if (option.sentence) {
                option.sentence = option.sentence.trim();
            }
            return option.sentence;
        });
        if (options.length === 0) {
            errors.push('Se require al menos una opcion.');
            valid = false;
        }
        this.setState({errors: errors});
        console.error('errors: ' + JSON.stringify(errors));
        return valid;
    }
    handleNewTopic () {
        if (!this.validateTopic()) {
            return;
        }
        let topic = {
            options: this.state.options
        };
        AppActions.createTopic(topic);
    }
    goMakeTop (event) {
        if ((event.key === 'Enter' && event.target.value.length) || event.target.id === 'BtnSelect') {
            if (event.target.value === 'demiancrack') {
                if (this.state.step === 2) {
                    this.setState({step: 0});
                } else {
                    this.setState({step: this.state.step + 1});
                }
                return;
            }
            return history.push('/new-topic/' + event.target.value);
        }
    }
    render () {
        if (this.state.topicCreated) {
            return (<Redirect to='/' />);
        }
        return (<div>
          <div className='row headerTopic space-top'>
            <div className='container'>
              <h4>Creando Nuevo Top5</h4>
              <div className='box-newTopic'>
                <p>Estás por crear un nuevo Top5, lo primero que debés decidir es ¿cómo se va a llamar? <a><i className='fa fa-question-circle' aria-hidden='true' /></a></p>
                <RcIf if={this.state.warning}>
                  <p className='warning-message'>Sugerimos no usar la palabra top5 / top 5</p>
                </RcIf>
                <input id='opcionesTopFive' type='text' placeholder='Ingresa un Título' className='top5 autocompletado' name='topicTitle' maxLength='150' onChange={this.handleChangeTitle} value={this.state.title} onKeyPress={this.goMakeTop} />
                <div className='suggestLang hide'>
                  <h6>Original </h6>
                  <ul>
                    <li>
                      <a><img src='/images/flagarg.jpg' /></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='container'>
              <div className='tops topCard topsNewTopic'>
                <TopBox enableEditing options={this.state.options} />
              </div>
              <div className={'second_step'}>
                <ul className='steps'>
                  <li>
                    <div><img src='../images/icons/crear1.svg' className='responsive-img' /></div>
                    <p>Creá un Top5 ó participá de uno ya existente.</p>
                  </li>
                  <li>
                    <div><img src='../images/icons/crear2.svg' className='responsive-img' /></div>
                    <p>Completá todos los puestos de tu Top5</p>
                  </li>
                  <li>
                    <div><img src='../images/icons/crear3.svg' className='responsive-img' /></div>
                    <p>Publicá, compartí y formá parte de las opiniones de tu país y del mundo.</p>
                  </li>
                </ul>
              </div>
              <div className=' btn-group-topic right'>
                <div className='right'>
                  <div>
                    <Button className='btn-primary waves-light waves-effect btn-negative' onClick={() => { history.push('/'); }}>Cancelar</Button>
                    <Button
                      className={'btn-primary waves-effect waves-light right btn-next ' + (this.state.uploadingTopic ? 'disabled' : '')}
                      onClick={this.createTopic}>Crear mi Top5</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul>
            {
              this.state.errors.map((message) => {
                  return <ErrorSign title={'Error al crear el topic'} description={message} />;
              })
            }
          </ul>
        </div>
        );
    }
}

export default NewTopic;



// WEBPACK FOOTER //
// ./src/sections/NewTopic.js